import React, { Fragment } from 'react';
import { Image, Transition, TransitionGroup } from 'components';
import css from './carousel-image.scss';

export function CarouselImage({ children, className }) {
  return (
    <TransitionGroup component={className ? 'div' : null} className={className}>
      { children.map(url =>
        <Transition key={url} classNames={css.locals} timeout={1500}>
          <div className={css.wrap}>
            <Image className={css.image} src={url} />
          </div>
        </Transition>
      ) }
    </TransitionGroup>
  );
}
